<template>
  <div class="goodsList home_page">
    <!-- 类目 -->
    <div class="conditions">
      <Conditions :params="category"
                @changeChoosed="changeHandle"
      >
        <template v-slot:screenContent v-if="parentList.length">
          <el-col :span="24" class="flex-st">
            <div v-for="(item, index) in parentList"
                :key="item.categoryId" class="choosed_category_item">
            <i class="el-icon-arrow-right category_next" v-show="!(index===0)"></i>
            <div class="choosed_category">
              <div class="choosed_category_name" :title="item.categoryName">{{item.categoryName}}</div>
              <i class="el-icon-close category_close"
                 v-show="!(listType === '3' && index===0)"
                 @click="clearCategoryHandle(index)"></i>
            </div>
          </div>
          </el-col>
        </template>
      </Conditions>
      <Conditions :params="brand"
                  @changeChoosed="changeHandle"
      ></Conditions>
      <Conditions :params="series"
                  @changeChoosed="changeHandle"
      ></Conditions>
      <Conditions :params="{
                    ...attribute,
                    name: item.itemName,
                    dataList: item.valueList
                  }"
                  v-for="item in attrList"
                  :key="item.itemId"
                  @changeChoosed="changeHandle"
      ></Conditions>
      <el-row :span="24" class="text-center" v-show="attributeList.length>3">
        <el-button type="text"
                   v-show="showAllAttr"
                   @click="showAllAttr = !showAllAttr">{{this.$t('message.collapseAttribute')}}</el-button>
        <el-button type="text"
                   v-show="!showAllAttr"
                   @click="showAllAttr = !showAllAttr">{{this.$t('message.openAttribute')}}</el-button>
      </el-row>
    </div>
    <!-- 排序 -->
    <el-row class="good_sort">
      <el-col :span="1"
              class="default_sort_but cursor-pointer"
              :class="{'good_sort_default':(!sort.priceSort)}">
        <div @click="changeSortStatus(0)">默认</div>
      </el-col>
      <el-col :span="2">
        <div class="sort_item cursor-pointer price_sort_option">
          <div class="price_sort" @click="changeSortStatus(sort.priceSort + 1)">
            价格
            <div class="sort_status">
              <i class="el-icon-caret-top" :class="{'sort_status_selected':sort.priceSort == 1}"></i>
              <i class="el-icon-caret-bottom" :class="{'sort_status_selected':sort.priceSort  == 2}"></i>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- <div style="background:deeppink;height:200px;">
    </div> -->
    <good-list :goodList="goodList"
               :page="page.page"
               :total="page.total"
               :limit="page.limit"
               @refushDataList="getConditions">
    </good-list>
    <div class="no_show_message" v-show="!page.total">
      <img src="@/assets/img/good/noGood.png" alt="暂无相关商品">
      <div>暂无相关商品</div>
    </div>
  </div>
</template>

<script>
import GoodList from './components/goodList'
import Conditions from '@/components/screen-conditions'
export default {
  name: 'punchoutGoodsList',
  components: {
    GoodList,
    Conditions
  },
  data () {
    return {
      category: {
        name: '类别',
        count: 8,
        dataList: [],
        label: 'categoryName',
        dateKey: 'categoryId',
        choosed: '',
        id: 'category'
      },
      // 品牌
      brand: {
        name: '品牌',
        count: 8,
        dataList: [],
        label: 'name',
        dateKey: 'id',
        choosed: '',
        id: 'brand'
      },
      // 系列
      series: {
        name: '系列',
        count: 8,
        dataList: [],
        label: 'name',
        dateKey: 'id',
        choosed: '',
        id: 'series'
      },
      // 系列
      attribute: {
        name: '',
        count: 8,
        dataList: [],
        label: 'valueName',
        dateKey: 'valueId',
        multiple: true,
        choosed: [],
        id: 'attribute'
      },
      attributeList: [],
      parentList: [],
      categoryList: [],
      showAllAttr: false, // 显示所有的属性
      goodList: [],
      page: {
        page: 1,
        limit: 12,
        total: 0
      },
      sort: {
        // timeSort: 0, // 0 不显示 1 升序 2 降序
        priceSort: 0 // 0 不显示 1 升序 2 降序
      }
    }
  },
  computed: {
    searchFlg () {
      let flag = true
      if (this.searchStr) {
        flag = false
      } else if (this.category.choosed) {
        flag = false
      } else if (this.brand.choosed) {
        flag = false
      } else if (this.series.choosed) {
        flag = false
      } else if (this.attribute.choosed.length) {
        flag = false
      }
      return flag
    },
    // 检索内容
    searchStr () {
      return this.$route.query.searchStr || ''
    },
    attrList () {
      if (this.showAllAttr) {
        return this.attributeList
      } else {
        return this.attributeList.slice(0, 3)
      }
    },
    /**
     * 1. 检索列表
     * 2.品牌列表
     * 3.类目列表
     */
    listType () {
      let type = Number(this.$route.query.listType) || 1
      if (type >= 1 && type <= 3) {
        return type + ''
      } else {
        return '1'
      }
    }
  },
  watch: {
    '$route.query' () {
      this.init()
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.page.page = Number(this.$route.query.page) || 1
      this.page.limit = Number(this.$route.query.limit) || 12
      this.category.choosed = this.$route.query.categoryId || ''
      this.brand.choosed = this.$route.query.brandId || ''
      this.series.choosed = this.$route.query.seriesId || ''
      let attr = this.$route.query.attr
      let attrList = []
      if (attr) {
        attrList = attr.split(',')
      }
      this.attribute.choosed = attrList
      // 排序
      if (this.$route.query.priceSort) {
        this.sort.priceSort = (Number(this.$route.query.priceSort) % 3) || 0
      } else {
        this.sort.priceSort = 0
      }
      this.getConditions()
    },
    // 查询筛选条件的
    getConditions (page = this.page.page) {
      this.page.page = page
      let priceDesc = null
      let parentList = []
      if (this.sort.priceSort === 1) {
        priceDesc = 'asc'
      } else if (this.sort.priceSort === 2) {
        priceDesc = 'desc'
      }
      this.$http.post(`/front/punchout/commodity/commodityPageAndAttribute`, {
        ...this.page,
        categoryId: this.category.choosed,
        brandId: this.brand.choosed,
        seriesId: this.series.choosed,
        searchStr: this.searchStr,
        searchFlg: this.searchFlg,
        priceDesc: priceDesc,
        valueIdList: this.attribute.choosed
      })
        .then(({ data }) => {
          console.log(data, 'data')
          if (data.code !== 0) {
            this.page.total = 0
            this.brand.dataList = []
            this.goodList = []
            this.attributeList = []
            this.categoryList = []
            this.category.dataList = []
            this.parentList = parentList
            this.series.dataList = []
            return false
          }
          if (data.data.pageCommodity) {
            this.page.total = Number(data.data.pageCommodity.count) || 0
            this.goodList = data.data.pageCommodity.dataList
          } else {
            this.page.total = 0
            this.brand.dataList = []
          }
          if (data.data.attributeResult) {
            this.categoryList = data.data.attributeResult.categoryList || []
            if (this.category.choosed) {
              let list = []
              if (this.categoryList[0] && this.categoryList[0].categoryId) {
                list = this.categoryList[0].subList || []
                parentList = this.categoryList[0].parentList || []
                parentList.push({
                  categoryId: this.categoryList[0].categoryId,
                  categoryName: this.categoryList[0].categoryName
                })
              }
              this.category.dataList = list
              // if ()
            } else {
              this.category.dataList = this.categoryList
            }
            this.parentList = parentList
            this.brand.dataList = data.data.attributeResult.brandIdList || []
            this.series.dataList = data.data.attributeResult.seriesIdList || []
            this.attributeList = data.data.attributeResult.itemList || []
          } else {
            this.categoryList = []
            this.category.dataList = []
            this.parentList = parentList
            this.brand.dataList = []
            this.series.dataList = []
            this.attributeList = []
          }
        })
        .catch(() => {
          this.page.total = 0
          this.brand.dataList = []
          this.goodList = []
          this.attributeList = []
          this.categoryList = []
          this.category.dataList = []
          this.parentList = parentList
          this.series.dataList = []
        })
    },
    // 清除类目
    clearCategoryHandle (index) {
      let result = {
        key: 'category',
        value: ''
      }
      if (index > 0) {
        result.value = this.parentList[index - 1].categoryId
      }
      this.changeHandle(result)
    },
    // 更改类目返回结果
    changeHandle (result) {
      console.log(result, '====')
      if (result.key) {
        if (this.listType === '2' && result.key === 'brand') {
          return false
        }
        if (this.listType === '3' && result.key === 'category' && !result.value) {
          // 类目列表 一级类目不许取消
          return false
        }
        this[result.key].choosed = result.value
        this.page.page = 1
        // this.getConditions(1)
        this.routeHandle()
      }
    },
    // 默认排序
    changeSortStatus (priceSort) {
      this.sort.priceSort = priceSort % 3
      this.page.page = 1
      this.routeHandle()
    },
    routeHandle () {
      let attr = ''
      if (this.attribute.choosed.length) {
        attr = this.attribute.choosed.join()
      }
      this.$router.push({
        name: 'punchoutGoodsList',
        query: {
          searchStr: this.searchStr,
          categoryId: this.category.choosed,
          brandId: this.brand.choosed,
          seriesId: this.series.choosed,
          attr: attr,
          page: this.page.page,
          limit: this.page.limit,
          listType: this.listType,
          // 排序
          priceSort: this.sort.priceSort
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.conditions{
  margin-bottom: 10px;
  .flex-st{
    .choosed_category_item{
      display: flex;
      align-items: center;
      height: 30px;
    }
    // 已选中的类目展示
    .category_next{
      margin-left: 5px;
    }
    .choosed_category{
      border: 1px solid #1D65A8;
      margin-left: 5px;
      display: flex;
      height: 20px;
      line-height: 20px;
      // align-items: center;
      .choosed_category_name{
        padding: 0px 10px;
        line-height: 18px;
        font-size: 12px;
      }
      .category_close{
        background: #1D65A8;
        color: #fff;
        line-height: 20px;
        cursor: pointer;
      }
    }
  }
}
.goodsList{
  .no_show_message {
    margin: auto;
    text-align: center;
    .message {
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #999999;
      line-height: 22px;
    }
  }
  .good_sort{
    display: flex;
    margin: 6px 0 20px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    color: #666666;
    background: #fff;
    border: 1px solid #e1e1e1;
    /deep/ .price_sort_option .el-input__inner{
      background-color: rgb(245, 247, 250);
      cursor: not-allowed;
    }
    .default_sort_but{
      &:hover{
        background: #1D65A8;
        color: #fff;
      }
    }
    .good_sort_default{
      background: #1D65A8;
      color: #fff;
    }
    .sort_item{
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-left: 1px solid #e1e1e1;
      .sort_status{
        margin-left: 5px;
        font-size: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #bebebe;
        .sort_status_selected{
          color: #1D65A8;
        }
      }
      .price_sort{
        display: flex;
      }
    }
    .sort_center{
      justify-content: center;
    }
  }
}
</style>
